"use client";

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://haulkmqkgpdkfizncnoy.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhhdWxrbXFrZ3Bka2Zpem5jbm95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTE5NzIxNzEsImV4cCI6MjEwNzU0ODE3MX0.WPfkhLf3eWv72z_VeHc02WLSYa8VMl5eG1p3HngNzzU';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are missing');
}

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);